import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikSelect,
  FormikTextField,
  FIELD_REQUIRED,
  SupplierField,
} from 'src/modules/ui'

import { useMessages } from 'src/modules/messages'

import { usePurchasing } from '../../purchasing/hooks'

const mapToOption = ({ id, name }) => ({ value: id, label: name })

const MessageSupplierModal = ({
  environmentId,
  subject = '',
  supplier,
  ...props
}) => {
  const { purchasingEnvironments } = usePurchasing()
  const { sendMessage } = useMessages()

  const handleSubmit = ({ subject, message, environmentId }) =>
    sendMessage({
      supplierId: supplier.id,
      subject,
      text: message,
      environmentId,
    })

  const initialValues = {
    subject,
    message: '',
    environmentId,
  }

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required(FIELD_REQUIRED),
    message: Yup.string().required(FIELD_REQUIRED),
  })

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitText="Send Message"
      successNotification="Message sent to supplier"
      title="Contact Supplier"
      validationSchema={validationSchema}
      {...props}
    >
      <Form>
        <SupplierField label="To" supplier={supplier} />
        <FormikTextField
          autoFocus={subject === ''}
          fullWidth
          label="Subject"
          margin="normal"
          name="subject"
          type="text"
        />
        <FormikTextField
          autoFocus={subject !== ''}
          fullWidth
          label="Message"
          name="message"
          margin="normal"
          multiline
          minRows={10}
          type="text"
        />
        <FormikSelect
          fullWidth
          label="Related purchasing environment - optional"
          margin="normal"
          name="environmentId"
          options={[
            { value: '', label: 'Not related to any environment' },
            ...purchasingEnvironments.map(mapToOption),
          ]}
        />
      </Form>
    </FormikDialog>
  )
}

MessageSupplierModal.propTypes = {
  selectedEnvironment: PropTypes.number,
  supplier: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  subject: PropTypes.string,
  trigger: PropTypes.func,
}

MessageSupplierModal.defaultProps = {
  environmentId: '',
}

export default MessageSupplierModal
